import { Component, Input, OnInit } from '@angular/core';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';
import { ACCESS_TYPE } from '../../configs/enums/access-type.enum';
import { HealthSherpaSSOService } from '../../services/health-sherpa-sso.service';

@Component({
    selector: 'app-health-sherpa-sso-page-interstitial',
    templateUrl: './health-sherpa-sso-page-interstitial.component.html',
    styleUrls: ['./health-sherpa-sso-page-interstitial.component.scss'],
    standalone: false
})
export class HealthSherpaSsoPageInterstitialComponent implements OnInit {

  @Input() authoringContent: string;
  @Input() publishedContent: string;

  isAuthoring: boolean = null;

  ssoAttempted: boolean;

  constructor(
    private authoringMode: AuthoringModeService,
    private healthSherpaSSOService: HealthSherpaSSOService
  ) { }

  async ngOnInit() {
    this.isAuthoring = this.authoringMode.getAuthoringMode();

    if (!this.isAuthoring) {
      const passedPreSSOValidation: boolean = await this.healthSherpaSSOService.doSSO(ACCESS_TYPE.AGENT_CUBED);
      if (!passedPreSSOValidation) {
        this.ssoAttempted = true;
      }
    }
  }

}
